/**
 * /legal — centro de documentos legales de Structura Market.
 * Agrupado por categoría (Privacidad / Términos / Verificación), tarjeta por
 * tipo con descripción corta y acceso directo a leerlo — mismo espíritu que
 * un centro de políticas tipo Tiendanube. Mismo look que tunegocio (la
 * landing que enlaza esta página desde su footer).
 */
import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";
import {
  LEGAL_DOCUMENT_GROUPS,
  LEGAL_DOCUMENT_TITLES,
  LEGAL_DOCUMENT_DESCRIPTIONS,
  legalPublicHref,
} from "@/lib/legal-public-links";
import { publicSitePath } from "@/lib/public-site";
import { BrandMark, TunegocioLegalShell } from "@/components/legal/TunegocioLegalShell";

export const Route = createFileRoute("/legal/")({
  component: LegalIndexPage,
  head: () => ({
    meta: [{ title: "Documentos legales — Structura" }],
    links: [{ rel: "canonical", href: publicSitePath("/legal") }],
  }),
});

function LegalIndexPage() {
  return (
    <TunegocioLegalShell>
      <header className="px-6 py-4" style={{ borderBottom: "1px solid #E8ECF5" }}>
        <a href="/" className="inline-flex items-center gap-2 text-sm font-bold hover:opacity-70" style={{ color: "#0A1628" }}>
          <BrandMark size={22} />
          <span className="fd">
            tu<span style={{ color: "#1B4FD8" }}>negocio</span>
          </span>
        </a>
      </header>
      <main className="mx-auto max-w-4xl px-6 py-12">
        <h1 className="fd mb-2 text-3xl font-black tracking-tight" style={{ color: "#0A1628" }}>Documentos legales</h1>
        <p className="mb-10 text-sm" style={{ color: "#5A6B8C" }}>
          Términos, políticas y verificación comercial de Structura Market.
        </p>

        <div className="space-y-10">
          {LEGAL_DOCUMENT_GROUPS.map((group) => (
            <section key={group.title}>
              <h2 className="fd mb-4 text-lg font-bold" style={{ color: "#0A1628" }}>{group.title}</h2>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {group.types.map((type) => (
                  <a
                    key={type}
                    href={legalPublicHref(type)}
                    className="flex flex-col rounded-lg p-4 transition-colors hover:bg-[#F1F5FF]"
                    style={{ border: "1px solid #E8ECF5" }}
                  >
                    <div className="mb-2 flex items-center gap-2">
                      <FileText className="h-4 w-4 shrink-0" style={{ color: "#1B4FD8" }} />
                      <span className="font-semibold" style={{ color: "#0A1628" }}>
                        {LEGAL_DOCUMENT_TITLES[type]}
                      </span>
                    </div>
                    <p className="mb-3 flex-1 text-xs" style={{ color: "#5A6B8C" }}>
                      {LEGAL_DOCUMENT_DESCRIPTIONS[type]}
                    </p>
                    <span className="text-xs font-semibold" style={{ color: "#1B4FD8" }}>Leer documento →</span>
                  </a>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
      <footer className="px-6 py-6 text-center text-xs" style={{ borderTop: "1px solid #E8ECF5", color: "#8B98B5" }}>
        © {new Date().getFullYear()} tunegocio. Todos los derechos reservados.
      </footer>
    </TunegocioLegalShell>
  );
}
